import { DealPurchase } from './DealPurchase'

export default DealPurchase
